import React from "react";
import MuiTypography from "@mui/material/Typography";

type CprimeTextProps = React.ComponentProps<typeof MuiTypography>;

const CprimeText: React.FC<CprimeTextProps> = ({ sx, ...props }) => {
  return (
    <MuiTypography
      {...props}
      sx={{
        fontFamily: "ToyotaType-Regular",
        ...sx,
      }}
    />
  );
};

export default CprimeText;
